import { ENTITY_LISTING_VIEW_TYPE } from '../constants/common'
import {
  LIST_VIEW_TYPE_WITH_PREVIEW,
  LIST_VIEW_TYPE_WITHOUT_PREVIEW,
} from '../constants/listViewType'

export function isListViewTypeTableWithPreview(type) {
  return type === ENTITY_LISTING_VIEW_TYPE.tableWithPreview
}

export function isListViewTypeBoard(type) {
  return (
    type === ENTITY_LISTING_VIEW_TYPE.board ||
    type === ENTITY_LISTING_VIEW_TYPE.boardWithPreview
  )
}

export function isListViewTypeBoardWithPreview(type) {
  return type === ENTITY_LISTING_VIEW_TYPE.boardWithPreview
}

export function isListViewTypeCalendar(type) {
  return type === ENTITY_LISTING_VIEW_TYPE.calendar
}

export function isListViewTypeWithPreview(type) {
  return (
    isListViewTypeTableWithPreview(type) || isListViewTypeBoardWithPreview(type)
  )
}

export function getListViewTypeWithPreview(type) {
  return LIST_VIEW_TYPE_WITH_PREVIEW[type] ?? type
}

export function getListViewTypeWithoutPreview(type) {
  return LIST_VIEW_TYPE_WITHOUT_PREVIEW[type] ?? type
}

export function isListViewTypeBodyChanged({ listViewType, nextListViewType }) {
  return (
    getListViewTypeWithoutPreview(listViewType) !==
    getListViewTypeWithoutPreview(nextListViewType)
  )
}
